/*
 * @Author: wuxi
 * @Date: 2022-04-21 17:50:25
 * @LastEditors: wuxi
 * @LastEditTime: 2022-04-21 18:32:36
 * @FilePath: \csx-b2b-front-supplier\components\HOC\product\index.js
 * @Description:商品
 */
import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_LIKE_PRODUCT_LIST, API_GET_NEW_BENEFIT_BBC_PRODUCT_QUERY } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class Product extends React.PureComponent {
  state = {
    AddCodeData: [],
    loading: false,
  };

  componentDidMount() {
    const { isReturn } = this.props;
    if (!isReturn) {
      this.getAddCodeFunc();
    }
  }

  // 获取商品
  getAddCodeFunc = value => {
    const { isReturn } = this.props;
    this.setState({ loading: true, AddCodeData: [] });
    getData({
      api: isReturn ? API_GET_NEW_BENEFIT_BBC_PRODUCT_QUERY : API_LIKE_PRODUCT_LIST,
      searchParams: {
        keyword: value,
        size: 10,
      },
    })
      .then(res => {
        const { data } = res;
        this.setState({
          AddCodeData: data,
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  @Bind()
  @Debounce(1000)
  handleSearch(value) {
    if (!value) return false;
    this.getAddCodeFunc(value);
  }

  render() {
    const { AddCodeData, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'tags'}
        tokenSeparators={[' ', ',', '，', '	']}
        optionFilterProp="children"
        allowClear
        showArrow
        className="multiple-select-and-search"
        filterOption={false}
        notFoundContent={loading ? <Spin size="small" /> : '查询结果为空'}
        onSearch={this.handleSearch}
        showSearch
        dropdownMatchSelectWidth={false}
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {AddCodeData.map(item => (
          <Select.Option
            title={`${item.code}-${item.name}`}
            key={item.code}
            item={item}
            value={
              renderValue ? renderValue(item) : `${item.code}-${item.name}`
            }>{`${item.code}-${item.name}`}</Select.Option>
        ))}
      </Select>
    );
  }
}

export default Product;
